module.exports = __webpack_public_path__ + "img/selected0-min.1547752f.png";